import { EXPENSE_CONST } from '../actionConstants';
import { EXPENSE_STATUS_MODAL } from '../../expense/config';

const INITIAL_STATE = {
	apiLoading: false,
	apiStatus: '',
	msgData: false,
	nonBizExpnsCat: [],
	bizExpnsCat: [],
	bizExpnsList: [],
	addExpnsModalStep: '',
	openModal: '',
	fileUrlData: null,
	expenseData: null,
	uploadedFileId: '',
	moreMyBizList: false
};

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}

	const { type, payload = {} } = action;

	switch (type) {
		case EXPENSE_CONST.API_LOADING: {
			const { loading, isPopup, data, apiType = '' } = payload;
			return {
				...state,
				apiLoading: isPopup ? false : loading,
				msgData: data || false,
				apiType: apiType,
				apiStatus: isPopup && loading ? EXPENSE_STATUS_MODAL.LOADING : ''
			};
		}
		case EXPENSE_CONST.API_SUCCESS: {
			return {
				...state,
				apiLoading: false,
				msgData: payload.data || false,
				apiError: true,
				apiStatus: EXPENSE_STATUS_MODAL.SUCCESS,
				openModal: payload.openModal || true
			};
		}
		case EXPENSE_CONST.API_ERROR: {
			const { data = false } = payload;
			return {
				...state,
				apiLoading: false,
				msgData: data,
				apiStatus: EXPENSE_STATUS_MODAL.ERROR,
				openModal: typeof data.openModal === 'undefined' ? true : data.openModal
			};
		}
		case EXPENSE_CONST.RESET_API_STATE: {
			return {
				...state,
				apiLoading: false,
				msgData: false,
				apiStatus: '',
				openModal: '',
				apiType: ''
			};
		}
		case EXPENSE_CONST.EXPNS_MODAL: {
			return {
				...state,
				openModal: payload.modalType || ''
			};
		}
		case EXPENSE_CONST.EXPENSE_CAT: {
			const { nonBizExpnsCat, bizExpnsCat } = payload;
			return {
				...state,
				nonBizExpnsCat,
				bizExpnsCat
			};
		}
		case EXPENSE_CONST.BIZ_EXPNS_LIST: {
			const { myBizList, nextPage } = payload;
			return {
				...state,
				bizExpnsList: [...state.bizExpnsList, ...myBizList],
				moreMyBizList: nextPage
			};
		}
		case EXPENSE_CONST.EXPNS_MODAL_STEP: {
			return {
				...state,
				addExpnsModalStep: payload
			};
		}
		case EXPENSE_CONST.EXPNS_RECEIPT_URL: {
			const { name, imageUrl, expenseId, error = false, id = null } = payload;
			const { fileUrlData } = state;
			let newFileUrlData = {};
			if (fileUrlData) {
				const expenseFileData = fileUrlData[expenseId] ? {
					...fileUrlData[expenseId],
					[name]: {
						imageUrl,
						error,
						id
					}
				} : {
					[name]: {
						imageUrl,
						error,
						id
					}
				};
				newFileUrlData = {
					...fileUrlData,
					[expenseId]: expenseFileData
				};
			} else {
				newFileUrlData[expenseId] = {
					[name]: {
						imageUrl,
						error,
						id
					}
				};
			}
			return {
				...state,
				fileUrlData: newFileUrlData,
				uploadedFileId: name
			};
		}
		case EXPENSE_CONST.EXPNS_DATA: {
			return {
				...state,
				expenseData: payload
			};
		}
		case EXPENSE_CONST.CLEAR_EDIT_MODAL_DATA: {
			return {
				...state,
				nonBizExpnsCat: [],
				bizExpnsCat: [],
				bizExpnsList: [],
				addExpnsModalStep: '',
				uploadedFileId: '',
				moreMyBizList: false,
				fileUrlData: null
			};
		}
		default:
			return state;
	}
};
